import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import CustomModal from "../../../../Panel/Common/Components/Modal/CustomModal";
import { ToDateJalali } from "../../../../Web/Common/Function";
function RecciveOffer({ data,isApp }) {
  const [modal, setModal] = useState(false);
  return (
    <div className={!isApp && "row mt-4 "}>
      <div className="clup-card">
        <div className="titre">
          <i
            className="fas fa-smile"
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
          <h6 className={isApp && "border-bottom pb-2 mb-2 w-100"}>تخفیف های دریافتی</h6>
        </div>
        <div className="row card-box">
          {data.map((off, key) => {
            return <Cards key={key} setModal={setModal} off={off} />;
          })}
        </div>
        <CustomModal
          handleClose={() => {
            setModal(false);
          }}
          size={"sm"}
          header={"اطلاعات تخفیف"}
          show={modal}
        >
          <Modal
            offer={
              modal &&
              data.filter(off => {
                return off.id == modal;
              })[0]
            }
          />
        </CustomModal>
      </div>
    </div>
  );
}
export default RecciveOffer;
const Cards = ({ setModal, off }) => {
  const type = () => {
    switch (off && off.product_type) {
      case "all":
        return "تمامی خدمات نیکوتن";
      case "joinclass":
        return "ثبت نام در کلاس های نیکوتن";
      case "reserve":
        return "رزرواسیون";
    }
  };
  return (
    <div
      className="col-md-6 mt-2"
      style={{ cursor: "pointer" }}
      onClick={() => {
        setModal(off && off.id);
      }}
    >
      <div className="card clups_cards">
        <div className="row mt-1">
          <div className="col-8  col-md-9">
            <div className="card-body">
              <div className="d-flex flex-column">
                <div className="d-flex p-1">
                  <h6>{type()}</h6>
                </div>
                <div className="d-flex  mb-1" style={{ paddingBottom: "8px" }}>
                  <span>{off && off.clupneed.text}</span>ّ
                </div>
                <div className="d-flex justify-content-end">
                  <span> پایان اعتبار : </span>
                  <span>{ToDateJalali(off && off.exp_time)}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-4  col-md-3 d-flex justify-content-center align-items-center"
            style={{ borderRight: "4px dotted #00000016" }}
          >
            <img
              src={off && off.clupneed.logo}
              className="img-fluid rounded-start "
              alt="..."
              width={"80%"}
              height={"80%"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Modal = ({ offer }) => {
  const type = () => {
    switch (offer.product_type) {
      case "all":
        return "تمامی خدمات نیکوتن";
      case "joinclass":
        return "ثبت نام در کلاس های نیکوتن";
      case "reserve":
        return "رزرواسیون";
    }
  };
  return (
    <div className="d-flex flex-column">
      <div>
        <img
          src={offer && offer.clupneed.image}
          alt=""
          width={"100%"}
          height={"150px"}
        />
      </div>
      <div
        className="mt-2 pb-1"
        style={{ borderBottom: "2px dashed #00000016" }}
      >
        <div className="d-flex align-items-end ">
          <div style={{ width: "30px", height: "30px", marginLeft: "5px" }}>
            <img
              src={offer && offer.clupneed.image}
              alt=""
              style={{ objectFit: "fill", width: "100%", height: "100%" }}
            />
          </div>
          <h6>{type()}</h6>
        </div>
        <div
          className="d-flex justify-content-end "
          style={{ fontSize: "8px" }}
        >
          <span>امتیاز مورد نیاز</span>
          <span>{offer && offer.clupneed.score}</span>
        </div>
      </div>
      <div className="p-1">
        <p>{offer && offer.description}</p>
      </div>
      <div className="d-flex justify-content-center mt-1">
        <input
          type="text"
          value={offer && offer.code}
          readOnly
          style={{
            textAlign: "center",
            marginLeft: "5px",
            width: "100%",
            backgroundColor: "#00CBDA25",
            border: "1px solid #00CBDA",
            padding: "4px",
          }}
        />
        <CopyToClipboard
          text={offer && offer.code}
          onCopy={() => {
            toast.success("کد دعوت با موفقیت کپی شد");
          }}
        >
          <i
            className="far fa-copy "
            style={{
              alignSelf: "center",
              fontSize: "22px",
              cursor: "pointer",
            }}
          ></i>
        </CopyToClipboard>
      </div>
    </div>
  );
};
